import { memo } from "react"
import ApiError from "../../components/ApiError"
import { useAuditLog } from "../../hooks/useAuditLogs"
import SingleAuditLogTable from "../../components/SingleAuditLogTable"
import { useLocation, useNavigate } from "react-router-dom"
import { ArrowLeft } from "@phosphor-icons/react"
import LabeledValue from "../../components/LabeledValue"

const DataDisplay = ({ data }) => {
  const navigate = useNavigate()
  // Default data in case props are missing
  const accessionNumber = data.accessionNo ?? "N/A"
  const logData = data.logData ?? []
  const totalTokens = logData
    .filter((item) => !!item.numericValue)
    .reduce((sum, item) => sum + Number(item.numericValue), 0)

  const patientIssuer =
    Array.isArray(data?.logData) && data.logData.length > 0
      ? data.logData[0].patientIssuer
      : null

  const logId = data.logId ?? "N/A"
  const studyInstanceUid =
    Array.isArray(data?.logData) && data.logData.length > 0
      ? data.logData[0].studyInstanceUid
      : null
  data = {
    accessionNumber,
    totalTokens,
    patientIssuer,
    logId,
    studyInstanceUid,
  }

  const goBack = () => navigate(-1)

  return (
    <div className="bg-primary/10 rounded-md p-4 mx-4 mt-4">
      <div className="flex justify-start items-center gap-3">
        <ArrowLeft
          className="mb-2.5 cursor-pointer"
          size={24}
          onClick={goBack}
        />
        <h1 className="text-primary text-xl font-medium mb-3">
          Audit Logs Detail
        </h1>
      </div>
      <div className="grid grid-cols-4 gap-4 text-sm">
        <LabeledValue label="Accession Number:" value={data?.accessionNumber} />
        <LabeledValue label="Patient Issuer:" value={data?.patientIssuer} />
        <LabeledValue label="Log ID:" value={data?.logId} />
        <LabeledValue label="Total Tokens Used:" value={data?.totalTokens} />
        <LabeledValue
          label="Study Instance UID:"
          value={data?.studyInstanceUid}
        />
      </div>
    </div>
  )
}

const SingleAuditLog = () => {
  const location = useLocation()
  const rowData = location.state

  const { data, isLoading, error, isError } = useAuditLog(rowData.logId)

  if (isError) {
    return (
      <div className="mt-4">
        <ApiError axiosError={error} />
      </div>
    )
  }

  return (
    <div className="overflow-x-auto">
      <DataDisplay data={{ ...rowData, logData: data }} />
      <SingleAuditLogTable
        data={isLoading ? [] : data}
        loading={isLoading}
        pageCount={isLoading ? 0 : data.pages}
      />
    </div>
  )
}

export default memo(SingleAuditLog)
